<script setup>
/**
 * La idea de este componente es que hay un div oculto volando por ahí
 * al que le asociamos el popover de usuario. Cuando hacen click,
 * posicionamos este div oculto (popover-locator) al lado del ratón
 * y mostramos el popover en esa posición
 * Para mostrarlo hay que llamar dinámicamente al método mostrarPopoverUsuario
 * directamente. Lo hacemos así por performance
 */
import { useMouse } from '@vueuse/core';
import { ref } from 'vue';
import { doubleRaf } from '../../libs/animate';
import PopoverUsuario from './PopoverUsuario.vue';

const props = defineProps({
  // Cuando click en este tipo de clases, mostramos el modal, no lo
  // cerraremos. Por ejemplo '.destinatario'
  targetSelector: { type: String, default: undefined },
  disabled: { type: Boolean, default: false },
});

const usuarioPopover = ref();

const { x, y } = useMouse({ target: document.body });

const showUsuarioPopover = ref(false);
const popover = ref();
const popoverWrapper = ref();

/**
 * Si hacen click en otro usuario no ocultamos el popover, si no
 * ocultamos al hacer click fuera
 */
function hayQueOcultarPopover(event) {
  if (!event?.target || !props.targetSelector) {
    return true;
  }
  return !event.target.closest(props.targetSelector);
}

/**
 * Función para asignar el usuario y mostrar su información
 */
function mostrarPopoverUsuario(usuario) {
  if (props.disabled || !usuario) {
    return;
  }

  popoverWrapper.value.style.top = `${y.value - 14}px`;
  popoverWrapper.value.style.left = `${x.value + 8}px`;

  usuarioPopover.value = usuario;
  if (!showUsuarioPopover.value) {
    doubleRaf(() => {
      if (!showUsuarioPopover.value) {
        showUsuarioPopover.value = true;
      }
    });
  }
}

defineExpose({ mostrarPopoverUsuario });
</script>

<template>
  <Teleport to="body">
    <div ref="popoverWrapper" class="popover-locator">
      <PopoverCifra
        ref="popover"
        v-model:show="showUsuarioPopover"
        :triggers="[]"
        :auto-hide="hayQueOcultarPopover"
      >
        <template #contenido>
          <PopoverUsuario
            v-if="usuarioPopover"
            :usuario="usuarioPopover"
          />
        </template>
      </PopoverCifra>
    </div>
  </Teleport>
</template>

<style lang="scss" scoped>
@import "@/../assets/stylesheets/cifra/vars/main.scss";

.popover-locator {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 1px;
  width: 1px;
}
</style>
